import { INTRO_THEMES, getDemoIntroKey, type IntroKey } from "@/lib/seasonalIntro";

/** Selector de prueba: solo visible cuando la dirección lleva ?intro=... */
export default function IntroDemoSwitcher() {
  const current = getDemoIntroKey();
  if (!current) return null;
  const go = (k: IntroKey) => {
    const url = new URL(window.location.href);
    url.searchParams.set("intro", k);
    window.location.assign(url.toString());
  };
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex gap-1 rounded-full border bg-background/90 p-1 shadow-md text-xs">
      <span className="px-2 py-1 text-muted-foreground">Demo intro:</span>
      {(Object.keys(INTRO_THEMES) as IntroKey[]).map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => go(k)}
          className={`rounded-full px-3 py-1 ${k === current ? "bg-primary text-primary-foreground" : "text-foreground"}`}
        >
          {INTRO_THEMES[k].label}
        </button>
      ))}
    </div>
  );
}
